import { Component, Element, h, Host, Listen, State } from '@stencil/core';

@Component({
  tag: 'envc-accordion-img-container',
  styleUrl: 'envc-accordion-img-container.scss',
})

export class EnvcAccordionImgContainer {
  // Root Element der Komponente
  @Element() host: HTMLElement;
  @State() imageSlot: HTMLEnvcAccordionImgElement;

  private init(): void {
    this.imageSlot = this.host.querySelector("[slot='image']");
  }

  private setUrl(sourceElement: HTMLEnvcAccordionItemElement): void {
    if (!this.imageSlot) return;
    if(!sourceElement){
      this.imageSlot.url = '';
    } else {
      sourceElement.getImageUrl().then((url) => {
        this.imageSlot.url = url;
      });
    }
  }

  /** Wird aufgerufen, wenn die Komponente geladen wird. */
  componentWillLoad(): void {
    this.init();
  }

  @Listen('accItemOpen')
  async onAccordionItemOpen(event: CustomEvent) {
    this.setUrl(event.target as HTMLEnvcAccordionItemElement);
  }

  @Listen('accInitialItemOpen')
  async onAccordionInitialItemOpen(event: CustomEvent) {
    this.setUrl(event.target as HTMLEnvcAccordionItemElement);
  }

  @Listen('accItemClose')
  async onAccorionItemClose() {
    this.setUrl(null);
  }

  render() {
    return (
      <Host class="accordion-with-image-container">
        <slot name="accordion"></slot>
        <slot name="image"></slot>
      </Host>
    );
  }
}
